// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { Router, Switch } from 'react-router-dom';
import { Layout } from '../ui/layout/Layout';
import { LoginLayout } from '../ui/layout/LoginLayout';
import { ProtectedLayout } from '../ui/layout/ProtectedLayout';
import { Dashboard } from '../ui/pages/dashboard/Dashboard';
import { DeviceUpdater } from '../ui/pages/device-updater/DeviceUpdater';
import { Login } from '../ui/pages/login/Login';
import { SAMLCallback } from '../ui/pages/login/SAMLCallback';
import { NoMatch } from '../ui/shared/NoMatch';
import { Popups } from '../ui/shared/popups/Popups';

const history = createBrowserHistory();

const asyncComponent = (getComponent: () => Promise<React.Component>) => {
  class AsyncComponent extends React.Component {
    private static Component = null;

    public state = { Component: AsyncComponent.Component };
    public render(): React.ReactElement {
      const { Component } = this.state;
      if (Component) {
        return <Component {...this.props} />;
      }
      return null;
    }

    public UNSAFE_componentWillMount(): void {
      if (!this.state.Component) {
        getComponent().then((Component: React.Component): void => {
          AsyncComponent.Component = Component;
          this.setState({ Component });
        });
      }
    }
  }
  return AsyncComponent;
};

const PasswordResetAsync = asyncComponent((): any =>
  import('../ui/pages/login/PasswordReset').then(
    (module) => module.PasswordReset
  )
);

const Pages = (): React.ReactElement => {
  return (
    <React.Fragment>
      <Router history={history}>
        <Popups />
        <Switch>
          <LoginLayout exact path='/' component={Login} />
          <LoginLayout
            exact
            path='/passwordreset'
            component={PasswordResetAsync}
          />
          <LoginLayout
            exact
            path='/auth/saml/callback'
            component={SAMLCallback}
          />
          <ProtectedLayout
            exact
            path='/updater'
            component={DeviceUpdater}
          />
          <ProtectedLayout
            path={'/:entityType/:entityId'}
            component={Dashboard}
          />
          <ProtectedLayout path={'/:entityType'} component={Dashboard} />
          <Layout component={NoMatch} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export { Pages };
